import RestReducer, { errors } from 'redux-rest-reducer';
import { ACTIONS as logoutActions } from 'actions/logout';

export default RestReducer({
  FLUSH_ACTIONS: [logoutActions.POST_SUCCESS, errors[401]],
});
